(function(){

  angular
    .module('iqxCore')
    .service('socketSvc', socketSvc)
    
  function socketSvc(newVersionSvc, $window) {
    var svc = this
    svc.connect = connect

    ///////////

    function connect(){
      var hostURL = $window.location.protocol + "//" + $window.location.hostname + ($window.location.port ? ":" + $window.location.port : '')
      var isSecure = ($window.location.protocol == "https:" ? true : false)
      var socket = io.connect(hostURL, {secure:isSecure, transports:['websocket']}) // will force use of websocket as otherwise sockeet.io will not work with nodeJS clusters

      socket.on('newVersionAvailable', newVersionSvc.setAvailable)
    }

  }

})()